export enum FiApplicationLanguageType {
    Swedish = 1,
    English = 2,
    Danish = 3,
    Norwegian = 4,
    Finnish = 5,
    French = 6,
    Estonian = 7,
    Spanish = 8,
    German = 9,
    Italian = 10,
    Chinese = 11,
    Catalan = 12,
    Dutch = 13,
    Arabic = 14,
    Mongol = 15,
    Vietnamese = 16,
    Icelandic = 17,
    Turkish = 18,
}
